import { render, staticRenderFns } from "./RequestsPage.vue?vue&type=template&id=6d677506&"
import script from "./RequestsPage.vue?vue&type=script&lang=ts&"
export * from "./RequestsPage.vue?vue&type=script&lang=ts&"
import style0 from "./RequestsPage.vue?vue&type=style&index=0&id=6d677506&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports